import React, { createContext, useCallback, useContext, useState } from "react";

// Create the Form Context
const FormContext = createContext();

/**
 * FormProvider component that wraps form components and provides shared context
 * This context now only contains legacy functionality that hasn't been moved to split contexts yet
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components
 */
export const FormProvider = ({ children }) => {
  // Legacy state - this will be removed once all components are updated

  // Context value object - now empty as all functionality moved to split contexts
  const value = {};

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

/**
 * Custom hook to use the Form Context
 * @returns {Object} Form context value
 * @throws {Error} If used outside of FormProvider
 */
export const useFormContext = () => {
  const context = useContext(FormContext);

  if (context === undefined) {
    throw new Error("useFormContext must be used within a FormProvider");
  }

  return context;
};

export default FormContext;
